module.exports = __webpack_public_path__ + "img/d4sj-btn.8e5bb94b.png";